import * as React from "react";
import type { SVGProps } from "react";
const SvgSettingKlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="setting_kline_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M341.333 256a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192H896a42.667 42.667 0 1 0 0-85.334H548.48a149.419 149.419 0 0 0-143.147-106.666zM213.333 256a42.667 42.667 0 0 1-42.666 42.667H128a42.667 42.667 0 0 1 0-85.334h42.667A42.667 42.667 0 0 1 213.333 256zM640 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192H896a42.667 42.667 0 1 0 0-85.334h-48.853A149.419 149.419 0 0 0 704 362.667zM512 512a42.667 42.667 0 0 1-42.667 42.667H128a42.667 42.667 0 1 1 0-85.334h341.333A42.667 42.667 0 0 1 512 512zM320 704a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM128 810.667h48.853A149.419 149.419 0 0 0 469.333 768a149.333 149.333 0 0 0-292.48-42.667H128a42.667 42.667 0 1 0 0 85.334zm426.667-85.334a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H554.667z"
    />
  </svg>
);
export default SvgSettingKlineIcon;
